import { STEP_NAME } from './types';

export const DefaultTransferForm = [
  STEP_NAME.PATIENT,
  STEP_NAME.INTRO,
  STEP_NAME.PLACEHOLDER, // We start the form with no Doctor or Pharmacy step, since that is defined in the "Intro" step.
  STEP_NAME.MEDICATIONS,
  STEP_NAME.CONFIRMATION,
];
